import { Component, ElementRef } from "@angular/core";
import { GlobalService } from "../../_services/global.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

import { RouterProjectService } from "../../_services/router-project.service";
import { AuthenticationService } from "../../_services/authentication.service";
@Component({
  selector: "app-header",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.css"],
})
export class AppHeader {
  manualUrl = "https://docs.google.com/presentation/d/1eSs5sj_ZHT-qbh4tW332xEKoCfFiWqdBNGtCrA-yO50/edit?usp=sharing"
  isCollapsed = true;
  isFreshing = false;
  linkPrefix = "";
  loginCAS = false;
  account: any;
  projects: any;
  projectKeys: Array<string>;
  constructor(
    private el: ElementRef,
    private router: Router,
    private globalService: GlobalService,
    private routerProjectService: RouterProjectService,
    private authenticationService: AuthenticationService,
    private toastrService: ToastrService
  ) {}

  // wait for the component to render completely
  ngOnInit(): void {
    var nativeElement: HTMLElement = this.el.nativeElement,
      parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
    // console.log(localStorage.getItem('currentSmmAccount'));
    this.account =
      localStorage.getItem("currentSmmAccount") !== undefined &&
      localStorage.getItem("currentSmmAccount") !== "undefined"
        ? JSON.parse(localStorage.getItem("currentSmmAccount"))
        : {};

    const routers = this.router.url.split("/");
    if (routers.indexOf("project") > -1) {
      this.linkPrefix = "/project/" + routers[2];
      this.routerProjectService.setData(routers[2]);
    }

    this.globalService.projectLoaded$.subscribe((callback) => {
      this.projects = callback;
      this.projectKeys = Object.keys(this.projects);
      this.globalService.getGeneralReportByProject().subscribe((res) => {
        if (res.success) {
          for (var key in this.projects) {
            for (var index in res.week.data) {
              if (
                this.projects[key]._id.toLowerCase().trim() ==
                res.week.data[index].key.toLowerCase().trim()
              ) {
                this.projects[key]["week"] = res.week.data[index];
              }
              if (
                res.day.data[index] &&
                this.projects[key]._id.toLowerCase().trim() ==
                  res.day.data[index].key.toLowerCase().trim()
              ) {
                this.projects[key]["day"] = res.day.data[index];
              }
            }
          }
        }
      });
    });

    this.loginCAS =
      localStorage.getItem("loginCAS") !== null
        ? JSON.parse(localStorage.getItem("loginCAS"))
        : false;
  }

  async logOut() {
    try {
      await this.authenticationService.saveLogLogout();
      localStorage.removeItem("currentSmmAccount");
      localStorage.removeItem("currentSmmData");
      localStorage.removeItem("loginCAS");
      localStorage.removeItem("cachedurl");
      location.reload();
      this.router.navigate(["/auth"]);
    } catch (error) {
      let message = "Không thể đăng xuất, vui lòng thử lại!"
      if(error._body && JSON.parse(error._body)) {
        message = JSON.parse(error._body).message
      }
      this.toastrService.error(message, "Lỗi");
    }
  }

  reload() {
    this.isFreshing = true;
    this.globalService.getGeneralReportByProject().subscribe((res) => {
      if (res.success) {
        for (var key in this.projects) {
          for (var index in res.week.data) {
            if (
              this.projects[key].name.toLowerCase().trim() ==
              res.week.data[index].key.toLowerCase().trim()
            ) {
              this.projects[key]["week"] = res.week.data[index];
            }
            if (
              res.day.data[index] &&
              this.projects[key].name.toLowerCase().trim() ==
                res.day.data[index].key.toLowerCase().trim()
            ) {
              this.projects[key]["day"] = res.day.data[index];
            }
          }
        }
      }
      this.isFreshing = false;
    });
  }

  getTitle(key, type, onlyNumber = false) {
    let result = "0/0";
    if (type == "day") {
      if (this.projects[key].day) {
        result =
          this.projects[key].day.processed.totalProcess.value +
          " / " +
          this.projects[key].day.doc_count;
      }
    }
    if (type == "week") {
      if (this.projects[key].week) {
        result =
          this.projects[key].week.processed.totalProcess.value +
          " / " +
          this.projects[key].week.doc_count;
      }
    }

    if (onlyNumber) {
      return result;
    }

    return `Đã Xử Lý ${result} Nội Dung`;
  }

  //projects[key].day.processed.totalProcess.value + '/' +  projects[key].day.doc_count
  getPercent(key, type) {
    let result = "0%";
    if (this.projects[key].day && this.projects[key].week) {
      if (type == "day") {
        result =
          Math.round(
            (this.projects[key].day.processed.totalProcess.value /
              this.projects[key].day.doc_count) *
              100
          ) + "%";
      } else {
        result =
          Math.round(
            (this.projects[key].week.processed.totalProcess.value /
              this.projects[key].week.doc_count) *
              100
          ) + "%";
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-header/app-header.component.ts